import React from 'react';
import useLazyBackgroundImage from '../../hooks/useLazyBackgroundImage';

const LazyServiceBanner = ({ 
  service, 
  serviceData, 
  onClick, 
  className = '',
  tabbable = true
}) => {
  const handleKeyDown = (e) => {
    // Allow normal tab behavior - don't interfere with Tab key
    if (e.key === 'Tab') {
      return;
    }
    
    // Stop event propagation for other keys to prevent carousel interference
    e.stopPropagation();
  };

  const handleClick = (e) => {
    // Stop event propagation to prevent carousel interference
    e.stopPropagation();
    onClick(e);
  };
  const { elementRef, isLoaded } = useLazyBackgroundImage(serviceData.imageUrl);

  return (
    <div 
      ref={elementRef}
      className={`service-banner-item ${className}`}
      style={{
        backgroundImage: isLoaded 
          ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${serviceData.imageUrl})`
          : 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6))',
        backgroundColor: isLoaded ? 'transparent' : '#2c2c2c',
        transition: 'background-image 0.3s ease-in-out'
      }}
    >
      <div className="service-banner-content">
        <h3 className="service-banner-title">{service}</h3>
        <p className="service-banner-description">{serviceData.description}</p>
        <div className="service-banner-overlay">
          <button 
            className="service-banner-cta"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            tabIndex={tabbable ? 0 : -1}
          >
            View Details
          </button>
        </div>
      </div>
      
      {/* Loading indicator */}
      {!isLoaded && (
        <div className="image-loading-indicator">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default LazyServiceBanner;
